import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT } from '../data/product';

/** Replace with the live checkout URL. */
const CHECKOUT_URL = '[CHECKOUT_URL]';
const included = ['6 complete volumes', '5 instant-use bonuses', '365-day quick-start calendar', '30 done-for-you finishers', 'Mixed-level scaling for every session', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ice text-ink" data-id="element-147" data-mp="1rtrodfwwz3i9">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-148" data-mp="25t0ufmreoh8i">
        <div className="text-center" data-id="element-149" data-mp="20tefn8vxisxl">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-150" data-mp="20sd6xb2dyij1">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-151" data-mp="3h97m7z5e12su">
            Every class for the next 52 weeks, already decided
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-ice-dark bg-white shadow-card" data-id="element-152" data-mp="4scmexh4pmqg">
          <div className="bg-navy px-5 py-5 text-center" data-id="element-153" data-mp="9ryxp1decswm">
            <h3 className="font-display text-xl uppercase tracking-wide text-white sm:text-2xl" data-id="element-154" data-mp="9qe2ran677y8">
              Bootcamp Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold text-gold-hover" data-id="element-155" data-mp="3daijbl1kl0ig">6 Volumes + 5 Bonuses</p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-156" data-mp="3i8bn67fehifk">
            <div className="overflow-hidden rounded-2xl bg-navy-deep px-3 py-4 sm:px-6 sm:py-6" data-id="element-157" data-mp="3n7etdv749up4">
              <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} width={1200} height={886} loading="lazy" className="mx-auto w-full max-w-[440px]" data-id="element-158" data-mp="3rxlidw5jjh7w" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-159" data-mp="2zf7r6fepmths">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-160" data-mp="2reicgld5utta">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-161" data-mp="2mhi423su9ez0">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-162" data-mp="2w7l3alqjzp5s" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-163" data-mp="28jtrrkcu7g5k">
              <p className="text-[13px] text-ink-soft" data-id="element-164" data-mp="23kqljwl4f3w0">
                Total value <span className="text-ink-muted line-through" data-id="element-165" data-mp="2ih7w4llhkehi">$97 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-166" data-mp="2dgtx1t1v4evm">
                <span className="mt-2.5 font-display text-3xl" data-id="element-167" data-mp="3tv3dm0zv4zbw">$</span>
                <span className="font-display text-[56px] leading-[0.9] sm:text-7xl" data-id="element-168" data-mp="3txg1eusay3wv">27</span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-169" data-mp="3oycz3i3pibsl">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-170" data-mp="cqbvt2wbe87">
                <span className="rounded border border-gold bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-171" data-mp="5b1jry9mrens">
                  Save $70
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-172" data-mp="3rh6wan3o3919">
                  One-time payment
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-173" data-mp="nyn4flowi56z">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-174" data-mp="e8bzpwxe7rz1">
                Get Bootcamp Ready now — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-175" data-mp="16q7jrm00wh2g">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-176" data-mp="3f8bjwnq1pjw5">
                <li className="flex items-center gap-1.5" data-id="element-177" data-mp="3a74a6j4ceamu">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-178" data-mp="358knuhlu6wty" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-179" data-mp="319k7d5qu06a4">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-180" data-mp="1svntsseyg34" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-181" data-mp="3szoz5pgx7vld">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-182" data-mp="3o7f1fn9kdr8j" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-183" data-mp="kk59f0fgkvb2">
          Price in USD. You&apos;ll be charged the equivalent in your local currency.
        </p>
      </div>
    </section>;
}